var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eden-filter',{attrs:{"width":270,"properties":_vm.properties,"disabled":_vm.disabled,"loading":_vm.loading},on:{"update:properties":function($event){_vm.properties=$event},"open":_vm.getData,"reset":_vm.reset,"filter":_vm.filter}})
}
var staticRenderFns = []

export { render, staticRenderFns }